import { ArrowDown2 } from "iconsax-reactjs";
import Dropdown, { DropdownOption } from "../../../commons/DataTableDropdown";

type Props = {
  value: string;
  placeholder: string;
  options: DropdownOption<string>[];
  icon: React.ReactNode;
  disabled?: boolean;
  onChange: (value: string) => void;
  className?: string;
};

export default function WizardSelect({
  value,
  placeholder,
  options,
  icon,
  disabled,
  onChange,
  className,
}: Props) {
  return (
    <div className={`h-12 w-full ${className ?? ""}`}>
      <Dropdown<string>
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        className="h-full w-full"
        menuWidth="260px"
        renderButton={(option, isOpen, buttonRef, toggleOpen) => (
          <button
            ref={buttonRef}
            type="button"
            disabled={disabled}
            onClick={(e) => {
              e.stopPropagation();
              toggleOpen();
            }}
            className="flex h-12 w-full items-center gap-2 rounded-xl border border-gray-300 px-4 text-base transition-colors focus:border-primaryVar-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            <span className="shrink-0 text-gray-400">{icon}</span>
            <span
              className={`flex-1 truncate text-right ${option ? "text-gray-800" : "text-gray-400"}`}
            >
              {option?.label ?? placeholder}
            </span>
            <ArrowDown2
              className={`shrink-0 text-gray-400 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
            />
          </button>
        )}
      />
    </div>
  );
}
